<template>
  <div>
    <div class="row new-row">
      <div class="col-3">
        <span>Fecha de Recepción:</span>
      </div>
      <div class="col-3">
        <span>No. Exp Relativo:</span>
      </div>

      <!-- <div class="col-3">
        <span>Acto Reclamado:</span>
      </div> -->
      <div class="col-3">
        <span>Detalles de Acto Reclamado:</span>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <input
          type="date"
          class="form-control"
          v-model="denuncia.fechaDeRecepcion"
          v-bind:disabled="bloquearFormulario"
        />
      </div>
      <div class="col-3">
        <input
          type="text"
          class="form-control"
          v-model="denuncia.numeroDeExpedienteRelativo"
          v-bind:disabled="bloquearFormulario"
        />
      </div>

      <!-- <div class="col-3">
        <C003TiposDeActoReclamado
          v-on:valorParaElPadre="cambioTipoDeActoReclamado"
          :prefijo="enumeraciones.etiquetasDeHTML.Select"
          :tipo="enumeraciones.tiposDeSelect.Seleccione"
          :deshabilitado="bloquearFormulario"
          :idDelInput="'catalogoTipoDeActoReclamado'"
          :parametros="{valorDefinido: -1,tipoDeActoReclamadoId: null,}"
          :valorDefinido="-1"
        >
        </C003TiposDeActoReclamado>
      </div> -->
      <div class="col-6">
        <textarea
          type="text"
          class="form-control bigtextarea"
          v-model="denuncia.detallesDeActoReclamado"
          v-bind:disabled="bloquearFormulario"
        />
      </div>
    </div>
    <div class="row new-row">
      <div class="col-3">
        <span>Estado de admisión:</span>
      </div>
      <div class="col-3">
        <span>Observaciones:</span>
      </div>
    </div>
    <div class="row">
      <div class="col-3">
        <C004TiposDeEstadoDeAdmision
          v-on:valorParaElPadre="cambioTipoDeEstadoDeAdmision"
          :prefijo="enumeraciones.etiquetasDeHTML.Select"
          :tipo="enumeraciones.tiposDeSelect.Seleccione"
          :deshabilitado="bloquearFormulario"
          :idDelInput="'catalogoTipoDeEstadoDeAdmision'"
          :parametros="{ valorDefinido: 1, tipoDeEstadoDeAdmisionId: null }"
          :valorDefinido="1"
        >
        </C004TiposDeEstadoDeAdmision>
      </div>
      <div class="col-3">
        <textarea
          class="form-control bigtextarea"
          v-model="denuncia.observaciones"
          v-bind:disabled="bloquearFormulario"
        ></textarea>
      </div>
    </div>
    <!-- Personas -->
    <Involucrados v-on:valorParaElPadre="cambioPersonas" :deshabilitado="bloquearFormulario"></Involucrados>
    <div class="row new-row">
      <div class="col-9"></div>
      <div class="col-3">
        <input
          type="button"
          value="Guardar Falta Administrativa"
          class="form-control"
          @click="registrarFaltaAdministrativa"
          v-bind:disabled="datosGeneralesNoValidos || bloquearFormulario"
        />
      </div>
    </div>
  </div>
</template>
<script>
import Vue from "vue";
import enumeraciones from "@/../static/js/enumeraciones";
import catalogos from "@/../static/js/catalogos";
import api from "@/../static/js/api";
import comun from "@/../static/js/comun";
import axios from "axios";
import Involucrados from "@/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/Involucrados.vue";
import { Denuncia } from "@/components/SIFA/Comun/Modelos/Denuncia.js";
import { Persona } from "@/components/SIFA/Comun/Modelos/Persona.js";
export default {
  data() {
    return {
      denuncia: new Denuncia(),
      bloquearFormulario: false,
      enumeraciones,
      catalogos      
    };
  },
  props: {
    prop_denuncia: Denuncia,
  },
  components: {
    Involucrados,
    C003TiposDeActoReclamado: catalogos.SIFA.C003TiposDeActoReclamado,
    C004TiposDeEstadoDeAdmision: catalogos.SIFA.C004TiposDeEstadoDeAdmision,
  },
  methods: {
    registrarFaltaAdministrativa: function () {
      this.denuncia.cargarDatosParaFormulario(["insertar-denuncia"]);
      var peticion = {
        denuncia: this.denuncia,
      };
      comun.SeEstaCargandoInformacion(true);
      axios
        .post(
          api.conexion + api.SIFA.funciones.RegistrarDenuncia,
          peticion /*, comun.CrearElHeaderDeAutorizacion(store.state.Login_AutorizacionOriginal)*/
        )
        .then((response) => {
          comun.SeEstaCargandoInformacion(true);
          if (response.data.SiHayError == false) {
            //En caso de que la petición sea exitosa
            this.bloquearFormulario = true;
            comun.mensajeDeAlerta(
              `${response.data.Satisfactorio}.\nNúmero de expediente de denuncia: ${response.data.consecutivo}`,
              null,
              null
            );
            this.$emit("valorParaElPadre", [
              response.data.denunciaId,
              response.data.consecutivo,
            ]);
          } else {
            console.error(response);
            comun.mensajeDeAlerta(response.data.Error.Mensaje, null, null);
          }
          comun.SeEstaCargandoInformacion(false);
        })
        .catch((e) => {
          console.error("encontre un error " + e);
          comun.mensajeDeAlerta(
            comun.mensajeDeError(enumeraciones.error.E500),
            null,
            null
          );
          comun.SeEstaCargandoInformacion(false);
        });
    },
    cambioPersonas(datos) {
      //Administra los cambios en el componente de Personas
      catalogos;
      this.denuncia.personas = datos;
    },
    cambioTipoDeActoReclamado(datos) {
      //Administra los cambios en el componente de Tipo de Acto Reclamado
      catalogos;
      this.denuncia.tipoDeActoReclamadoId = parseInt(datos[0].target.value);
    },
    cambioTipoDeEstadoDeAdmision(datos) {
      //Administra los cambios en el componente de Tipo de Estado De Admision
      catalogos;
      this.denuncia.tipoDeEstadoDeAdmisionId = parseInt(datos[0].target.value);
    },
  },
  mounted: function mounted() {
    if (this.prop_denuncia.denunciaId) {
      this.denuncia = this.prop_denuncia;
      this.bloquearFormulario = true;
    } else {
      this.denuncia.cargarDatosParaFormulario(["datos-generales"]);
    }
  },
  computed: {
    datosGeneralesNoValidos() {
      return (
        !this.denuncia.fechaDeRecepcion ||
        !this.denuncia.numeroDeExpedienteRelativo ||
        this.tipoDeEstadoDeAdmisionId === -1 ||
        this.involucradosNoValidos
      );
    },
    involucradosNoValidos(){
      return (
        this.denuncia.personas.filter(persona=> persona.tipoPersonaId === 1).length === 0 || this.denuncia.personas.filter(persona=> persona.tipoPersonaId === 2).length === 0
      )
    }
  },
};
</script>

<style scoped>
span {
  font-weight: bold;
}

b {
  padding-right: 3px;
}

.new-row {
  margin-top: 20px;
}
.bigtextarea {
  height: 100px;
}
</style>



// WEBPACK FOOTER //
// src/components/SIFA/AtencionDenuncias/RegistroDeDenuncia/DatosGenerales.vue